import React from 'react';
import { connect } from 'react-redux';
import { scrollIntoElement, clearScrollTo } from '../../store/scroll/actions';

const withScrollTo = WrappedComponent => {
  const mapStateToProps = state => ({
    scrollTo: state.scrollTo,
  });

  const mapDispatchToProps = dispatch => ({
    scrollIntoElement: () => dispatch(scrollIntoElement()),
    clearScrollTo: () => dispatch(clearScrollTo()),
  });

  const ScrollToContainer = props => <WrappedComponent {...props} />;

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(ScrollToContainer);
};

export default withScrollTo;



// WEBPACK FOOTER //
// ./src/containers/ScrollTo/index.js